var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"rule-link dropdown-item",class:_vm.linkClassName,attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.$emit('addNewRule', _vm.ruleType)}}},[_vm._v(_vm._s(_vm.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }